import React, { useEffect } from "react"
import DateTimePicker from '@mui/lab/DateTimePicker';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import { TextField } from '@mui/material';
import { getFormattedDate } from "../../Utils";


export default function DatePicker({handleChange, data, valueField}) {
    //const [value, setValue] = React.useState(null);
    const handleChangeDatePicker = async (newValue) => {
        let dataValue = await getFormattedDate(newValue)
        handleChange(dataValue, data.id)
        //setValue(newValue);
    };

    const value = valueField[data.id] ?? null
    return (
        <LocalizationProvider dateAdapter={AdapterDateFns} >
            <DateTimePicker
                label={data?.item}
                className={"williamGarcia"}
                value={value}
                fullWidth={true}
                onChange={handleChangeDatePicker}
                renderInput={(params) => <TextField {...params} />}
            />
        </LocalizationProvider>
    )
}